// import { useRouter } from 'next/router';
import type { PropsWithChildren } from 'react';
import { useEffect } from 'react';

import { useLogger } from '../hooks';
import type { LogParameters } from '../types';
import { LogParamsProvider } from '../utils';

interface LogScreenProps {
	params?: LogParameters;
	userId?: string;
}
export function LogScreen({ children, params, userId }: PropsWithChildren<LogScreenProps>) {
	// const router = useRouter();
	const logger = useLogger();
	// eslint-disable-next-line no-underscore-dangle
	const _params = userId ? { ...params, userId } : (params as LogParameters);

	// useEffect(() => {
	// 	if (params && router.isReady) {
	// 		logger.screen({ params: _params });
	// 	}
	// }, [router.isReady]);
	useEffect(() => {
		if (params) {
			logger.screen({
				params: {
					title: `LOG_SCREEN_${_params.title}`,
					..._params,
				},
			});
		}
	}, [params]);

	return <LogParamsProvider params={_params ?? null}>{children}</LogParamsProvider>;
}
